<template>
  <filter-updates :whats-new-data="whatsNewData"></filter-updates>
  <update-card></update-card>
</template>

<script>
  import UpdateCard from '@/views/whats-new/update-card/UpdateCard.vue'
  import FilterUpdates from '@/views/whats-new/FilterUpdates.vue'

  export default {
    name: 'Updates',
    components: { FilterUpdates, UpdateCard },
    props: {
      whatsNewData: {
        type: Array,
        required: true,
        default: () => []
      }
    }
  }
</script>
